export enum CHAT_CONSTANTS {
  BROADCAST_PAGE_SIZE = 25,
  GROUP_CHANNEL_PAGE_SIZE = 100,
  MESSAGE_PAGE_SIZE = 25,
  MAX_GROUP_PARTICIPANTS = 100,
  MIME_NOTIFICATION = 'text/notification',
  MAX_MESSAGE_LENGTH = 5000,
  REMAINING_CHARACTERS_LEFT_THRESHOLD = 100,
  ONE_YEAR_IN_SECONDS = 31556952,
  BROADCAST_SENDER_ID = 'broadcast_sender_id',
  MAX_FILE_ATTACHMENTS = 5,
  MAX_FILE_SIZE_IN_BYTES = 15728640, // Equivalent to 15MB
  MESSAGING_TEAM_MEMBER_LIMIT = 50,
  QUERY_USER_ID_LIMIT = 60,
  PREFETCH_DELAY = 7000,
  THUMBNAIL_DIMENSIONS_IN_PX = 320,
}

export enum CONNECTION_STATE {
  CONNECTED = 'connected',
  CONNECTING = 'connecting',
  DISCONNECTED = 'disconnected',
  RECONNECTING = 'reconnecting',
  INITIAL_CONNECT_FAILED = 'initial_connect_failed',
  RECONNECT_FAILED = 'reconnect_failed',
}

export enum LOGGING_TYPES {
  TEAM_CHANNEL_CREATION = 'team_channel_creation',
  NON_TEAM_CHANNEL_CREATION = 'non-team_channel_creation',
  PARTICIPANT_SELECTION = 'participant_selection',
  TEXT_MESSAGE_SENDING = 'text_message_sending',
  FILE_MESSAGE_SENDING = 'file_message_sending',
  FILE_ATTACHMENT = 'file_attachment',
  CONNECTION = 'connection',
  SHARED_WORKER_TABS_COUNT = 'sharedworker_tabs_count',
  ON_RECONNECT_SUCCEEDED_SENDBIRD_EVENT = 'on_reconnect_succeeded_sendbird_event',
  ON_RECONNECT_FAILED_SENDBIRD_EVENT = 'on_reconnect_failed_sendbird_event',
  PERFORMANCE_ISSUE = 'performance_issue',
  LOCAL_STORAGE_SIZES = 'localstorage-size',
  SET_BACKGROUND_ON_SMALLER_SCREENS = 'SET_BACKGROUND_ON_SMALLER_SCREENS',
  SET_FOREGROUND_ON_SMALLER_SCREENS = 'SET_FOREGROUND_ON_SMALLER_SCREENS',
}

export const MESSAGING_TAB_BASE_URL = '/messages';

// File Attachments
export enum FILE_TYPES {
  DOCUMENT = 'document',
  IMAGE = 'image',
}